<div class="footer">
    <span>{{content}}</span>
    <span> </span>
    <span>{{version}}</span>
</div>